<div class="ax-panel">
  <app-grid name="Global Factor Performance Attribution Factor Security Detail">
  </app-grid>
</div>
